import { BaseBus } from "./BaseBus";

export class CreditMemoWidgetUser extends BaseBus {
    constructor(busObj: CreditMemoWidgetUser = null) {
        super(busObj);
    }

    userId: string;
    regionIds: string[];
    divisionIds: string[];
    creditLimit: number;
    legalName: string;

    CID(): any {
        return this.userId;
    }
}